import MultiquoteCoverage from 'models/MultiquoteCoverage'

class VehicleCoverage {
    constructor({
        coverageId,
        quoteId,
        insuranceCompany,
        insuranceCompanyDisplayName,
        insuranceCompanyDisplayLongName,
        insuranceCompanyLogo,
        insuranceCompanyLogoSmall,
        insuranceCompanyLogoGrey,
        shortName,
        longName,
        subscriptionAmount,
        commission,
        commissionAmount,
        status,
        createdAt,
        budget,
        error,
        emission,
    }) {
        this.coverageId = coverageId
        this.insuranceCompany = insuranceCompany
        this.insuranceCompanyDisplayName = insuranceCompanyDisplayName
        this.insuranceCompanyDisplayLongName = insuranceCompanyDisplayLongName
        this.insuranceCompanyLogo = insuranceCompanyLogo
        this.insuranceCompanyLogoSmall = insuranceCompanyLogoSmall
        this.insuranceCompanyLogoGrey = insuranceCompanyLogoGrey
        this.shortName = shortName
        this.longName = longName
        this.name = longName
        this.subscriptionAmount = subscriptionAmount
        this.commission = commission
        this.commissionPercentage = commission
        this.commissionAmount = commissionAmount
        this.status = status
        this.createdAt = createdAt
        this.budget = budget ?? {}
        this.error = error ?? null
        this.emission = emission

        if (quoteId != null) {
            this.setQuoteId(quoteId)
        }
    }

    setQuoteId(quoteId) {
        this.id = quoteId
        this.quoteId = quoteId
    }

    static fromJson({
        id,
        insuranceCompany,
        insuranceCompanyLogos,
        emission,
        shortName,
        longName,
        error,
        subscriptionAmount,
        commission,
        commissionAmount,
        quoteId,
        budget,
        status,
        createdAt,
    }) {
        return new VehicleCoverage({
            coverageId: id,
            quoteId: quoteId ?? null,
            insuranceCompany,
            insuranceCompanyDisplayName: insuranceCompanyLogos?.displayName ?? null,
            insuranceCompanyDisplayLongName: insuranceCompanyLogos?.displayLongName ?? null,
            insuranceCompanyLogo: insuranceCompanyLogos?.logo ?? null,
            insuranceCompanyLogoSmall: insuranceCompanyLogos?.small ?? null,
            insuranceCompanyLogoGrey: insuranceCompanyLogos?.grey ?? null,
            shortName,
            longName,
            subscriptionAmount: subscriptionAmount ?? budget?.subscriptionAmount ?? null,
            commission: commission ?? null,
            commissionAmount: commissionAmount ?? null,
            status: status ?? null,
            createdAt: createdAt ?? null,
            budget: budget ?? {},
            error: error ?? null,
            emission: emission ?? null,
        })
    }

    static fromMultiquoteCoverage(coverage) {
        return new VehicleCoverage({
            coverageId: coverage.coverageId,
            quoteId: coverage.quoteId,
            insuranceCompany: coverage.insuranceCompany,
            insuranceCompanyDisplayName: coverage.insuranceCompanyDisplayName,
            insuranceCompanyDisplayLongName: coverage.insuranceCompanyDisplayLongName,
            insuranceCompanyLogo: coverage.insuranceCompanyLogo,
            insuranceCompanyLogoSmall: coverage.insuranceCompanyLogoSmall,
            insuranceCompanyLogoGrey: coverage.insuranceCompanyLogoGrey,
            shortName: coverage.shortName,
            longName: coverage.longName,
            subscriptionAmount: coverage.subscriptionAmount,
            commission: coverage.commission,
            commissionAmount: coverage.commissionAmount,
            status: coverage.status,
            createdAt: coverage.createdAt,
            budget: coverage.budget,
            error: coverage.error,
            emission: coverage.emission,
        })
    }

    static fromGroupedItem(insuranceCompany, item) {
        return VehicleCoverage.fromMultiquoteCoverage(
            MultiquoteCoverage.fromGroupedItem(insuranceCompany, item)
        )
    }
}

export default VehicleCoverage
